import { Condition } from "@redotech/redo-model/return-flow/condition";
import { validateAfterHoursCondition } from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type AfterHoursState = void;

export const AFTER_HOURS = (
  Details: React.ComponentType<ConditionTypeDetailsProps<AfterHoursState>>,
): ConditionType<AfterHoursState, Condition.AfterHours> => ({
  name: "Customer contacted after hours",
  description() {
    return "Customer contacted after hours";
  },
  Details(props: ConditionTypeDetailsProps<AfterHoursState>) {
    return React.createElement(Details, props);
  },
  empty: undefined,
  fromModel() {},
  toModel() {
    return { type: Condition.AFTER_HOURS };
  },
  valid() {
    return validateAfterHoursCondition({}).valid;
  },
});
